import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "quick-ship__wrapper" }
const _hoisted_2 = { class: "quick-ship__text" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://images.baldwinhardware.com/is/image/Baldwin/quickship-tiny?wid=121&qlt=100&op_sharpen=1",
  alt: "Quick Ship",
  class: "mr-2"
}, null, -1 /* HOISTED */)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "form-group__tooltip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconTooltip = _resolveComponent("IconTooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode("<span class=\"icon-quickship-bg\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span></span>\r\n            <h6 class=\"quick-ship__header\">{{ displayName }}</h6>"),
      _hoisted_3,
      _createElementVNode("p", {
        class: "quick-ship__description",
        innerHTML: $props.description
      }, null, 8 /* PROPS */, _hoisted_4),
      ($props.tooltip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_IconTooltip, {
              tooltipMessage: $props.tooltip,
              isIcomoonIcon: true,
              iconClass: "icon-info",
              isHtml: true
            }, null, 8 /* PROPS */, ["tooltipMessage"])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}